import { type PreviousEventRequest } from '@/Components/RepeatEvent/PreviousEventCard'

// Self-serve rejects two venue requests for the same space on one event
// (venue_requests_event_id_space_id_unique), so keep the first occurrence.
const dedupeVenueRequestsBySpaceId = (requests: PreviousEventRequest[]): PreviousEventRequest[] => {
  const seen = new Set<number>()
  return requests.filter((request) => {
    if (request.spaceId == null) return true
    if (seen.has(request.spaceId)) return false
    seen.add(request.spaceId)
    return true
  })
}

export default dedupeVenueRequestsBySpaceId
